/**
 This function is used in the Content Types header to determine if version history is enabled
 for a specific content type (i.e whiteboards/databases and any future content types)
 */
export const useIsVersionHistoryEnabled = (contentType: string | null | undefined): boolean => {
	return contentType === 'whiteboard' || contentType === 'database';
};
